module.exports = "/packs/000-96426edd4605c3d63d290ccf4e9b3119.jpg";